export const WalletAvatarIcon = () => (
  <svg
    width="24"
    height="23"
    viewBox="0 0 24 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="a" fill="#fff">
      <path d="M18.5 0a5.5 5.5 0 0 1 1.863 10.675 9 9 0 1 1-16.728 0A5.501 5.501 0 0 1 5.5 0a5.5 5.5 0 0 1 5.48 5.059A9 9 0 0 1 12 5q.516 0 1.019.059A5.5 5.5 0 0 1 18.5 0" />
    </mask>
    <path
      d="M18.5 0a5.5 5.5 0 0 1 1.863 10.675 9 9 0 1 1-16.728 0A5.501 5.501 0 0 1 5.5 0a5.5 5.5 0 0 1 5.48 5.059A9 9 0 0 1 12 5q.516 0 1.019.059A5.5 5.5 0 0 1 18.5 0"
      fill="#0e966f"
    />
    <path
      d="m20.363 10.675-.338-.941-.973.35.382.96zm-16.727 0 .929.37.382-.96-.972-.351zm7.344-5.616-.996.079.082 1.03 1.026-.116zm2.039 0-.112.993 1.027.116.081-1.03zM18.5 0v1A4.5 4.5 0 0 1 23 5.5h2A6.5 6.5 0 0 0 18.5-1zM24 5.5h-1a4.5 4.5 0 0 1-2.976 4.234l.34.94.338.942A6.5 6.5 0 0 0 25 5.5zm-3.637 5.175-.929.37c.364.914.566 1.91.566 2.955h2a10 10 0 0 0-.708-3.695zM21 14h-1a8 8 0 0 1-8 8v2c5.523 0 10-4.477 10-10zm-9 9v-1a8 8 0 0 1-8-8H2c0 5.523 4.477 10 10 10zm-9-9h1a8 8 0 0 1 .565-2.956l-.93-.37-.928-.369A10 10 0 0 0 2 14zm.636-3.325.339-.941A4.5 4.5 0 0 1 1 5.5h-2a6.5 6.5 0 0 0 4.297 6.116zM0 5.5h1A4.5 4.5 0 0 1 5.5 1v-2A6.5 6.5 0 0 0-1 5.5zM5.5 0v1c2.363 0 4.3 1.822 4.484 4.138l.996-.08.997-.079A6.5 6.5 0 0 0 5.5-1zm5.48 5.059.112.993Q11.545 6.001 12 6V4q-.578.001-1.132.065zM12 5v1q.456 0 .907.052l.112-.993.111-.994A10 10 0 0 0 12 4zm1.019.059.996.079A4.5 4.5 0 0 1 18.5 1v-2a6.5 6.5 0 0 0-6.478 5.98z"
      fill="#000"
      fillOpacity=".22"
      mask="url(#a)"
    />
  </svg>
);
